export default <T>(promise: Promise<T>): Promise<[Error | undefined, T]> =>
  promise
    .then<[undefined, T]>(data => [undefined, data])
    // tslint:disable-next-line: no-any
    .catch<[Error, any]>(error => [error, undefined])
